export default __webpack_public_path__ + "static/media/P314.3.e35379e6.mp3";